import React, { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'
import GenericNotice from 'src/components/GenericNotice/GenericNotice'
import { Button } from '@mui/material'

const HookUpdateForm = React.lazy(() => loadComponent('certification', 'HookUpdateForm'))

export function CertificateHookUpdateRoute() {
    const params = useParams()
    const navigate = useNavigate()
    const { academy, openFlightDeck } = useFlightDeck()

    const canUpdate = usePermission('certification.certificateconfiguration.update', { academy: academy?._id! })
    const canDelete = usePermission('certification.certificateconfiguration.delete', { academy: academy?._id! })

    const onDelete = useCallback(() => {
        navigate('/certificate_configurations')
    }, [navigate])

    const onUpdate = useCallback(() => {
        navigate('/certificate_configurations')
    }, [navigate])

    return (
        <RouteContainer>
            {!academy ? (
                <>
                    <GenericNotice
                        title="Keine Akademie ausgewählt"
                        message="Zertifikat Automationen gehören immer zu einer Akademie. Bitte wähle eine Akademie im Flight Deck aus, um dessen Zertifikat Automationen zu sehen">
                        <Button variant="contained" onClick={openFlightDeck}>
                            Flight Deck öffnen
                        </Button>
                    </GenericNotice>
                </>
            ) : (
                <HookUpdateForm
                    _id={params._id}
                    academyId={academy?._id}
                    canDelete={canDelete}
                    canUpdate={canUpdate}
                    onDelete={onDelete}
                    onUpdate={onUpdate}
                />
            )}
        </RouteContainer>
    )
}
